let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1AL2L")).then(() => parcelRequire('8xjMP'));